module.exports = __webpack_public_path__ + "static/media/Kemendikbud - Baru (1).b774e256.png";